import { CalendarRangeIcon } from './CalendarRangeIcon';

/**
 * author: Google
 * id 740D7A91-7492-4922-96C7-A719E2BCD62A
 * name calendar-range
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-range.svg
 * tags
 * - Date / Time 
 */
export const EventRangeIcon = CalendarRangeIcon;
export default EventRangeIcon